export const STORE_PAGE_EVENT_MONORAIL_SCHEMA =
  'shipping_delivery_promise_online_store_page_event/4.3';
export const BUY_WITH_PRIME_STORE_PAGE_EVENT_MONORAIL_SCHEMA =
  'buy_with_prime_promise_online_store_page_event/1.1';
export const DELIVERY_PROMISE_FRONTEND_EVENT =
  'delivery_promise_frontend_events/1.1';
export const OPEN_POSTAL_CODE_FORM = 'open_postal_code_form';
export const CLOSE_POSTAL_CODE_FORM = 'close_postal_code_form';
export const DELIVERY_PROMISE_ERROR = 'delivery_promise_error';
export const FETCH_DELIVERY_PROMISE_EVENT_TYPE = 'fetching_delivery_promise';
export const UNABLE_TO_MOUNT = 'unable_to_mount';
